/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
import { getCompletion } from '@/api/characteristics';
import { Box, Button, Typography } from '@mui/material';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { CompletionData } from '../../api/characteristics/types';
import { convertArchivedReason, Status } from '../../api/enumerations';
import {
  AssociationWOData,
  CheckWorkOrderRegistryParams,
} from '../../api/registryAssociation/types';
import { getSample } from '../../api/samples';
import { ElementData } from '../../api/samples/types';
import { GetWorkOrder } from '../../api/workOrders';
import { WorkOrderData } from '../../api/workOrders/types';
import { AllAttachments } from '../../components/AllAttachments';
import { AssociateWorkOrderDialog } from '../../components/AssociateWorkOrderDialog';
import { ExportSample } from '../../components/ExportSample';
import { MessagesDialog } from '../../components/Messages';
import { AccordionTitle } from '../../components/Sections/AccordionTitle';
import { AssociatedWorkOrders } from '../../components/Sections/AssociatedWorkOrders';
import { ClientData } from '../../components/Sections/ClientData';
import { FormResponse } from '../../components/Sections/FormResponse';
import { PdfViewer } from '../../components/Sections/PdfViewer';
import { PropertyAddressWithMaps } from '../../components/Sections/PropertyAddressWithMaps';
import { PropertyData } from '../../components/Sections/PropertyData';
import { PropertyInfo } from '../../components/Sections/PropertyInfo';
import { ReportDownload } from '../../components/Sections/ReportDownload';
import { Rooms } from '../../components/Sections/Rooms';
import { SampleSection } from '../../components/Sections/Sample';
import { ScheduleInfo } from '../../components/Sections/ScheduleInfo';
import { Title } from '../../components/Sections/Title';
import { ToogleAccordion } from '../../components/Sections/ToogleAccordion';
import Snackbar from '../../components/Snackbar';
import {
  BoxContainer,
  FlexReverseBox,
  LoadingBox,
} from '../../components/UI/Box';
import { BackButton } from '../../components/UI/Button';
import { GridContainer } from '../../components/UI/Grid';
import {
  ColoredCircularProgress,
  WhiteCircularProgress,
} from '../../components/UI/Typography';
import { Constants } from '../../constants/archived';
import { factorTypes } from '../../constants/evaluationTypes';
import {
  IconApartmentMS,
  IconArrowCircleLeftMS,
  IconAssignmentMS,
  IconCalendarTodayMS,
  IconDescriptionMS,
  IconEngineeringMS,
  IconFactCheckMS,
  IconListAltMS,
  IconLocationCityMS,
  IconLocationOnMS,
  IconPhotoLibraryMS,
} from '../../constants/icons';
import { GlobalContext } from '../../context/global';
import { useAccordion } from '../../hooks/useAccordion';
import {
  AssociateProps,
  useAssociateWorkOrder,
} from '../../hooks/useAssociateWorkOrder';
import useErrorMessage from '../../hooks/useErrorMessage';
import useGeneral from '../../hooks/useGeneral';
import { useRooms } from '../../hooks/useRooms';
import { CharacteristicsSectionSummary } from '../Characteristics/components/SectionSummary';
import {
  FlexSpaceBetweenBox,
  InputTitle,
  SectionBox,
  StyledInput,
  SubmitBox,
} from './styles';

export function Archived(): JSX.Element {
  const [propertyData, setPropertyData] = useState<WorkOrderData>();
  const [sampleData, setSampleData] = useState<ElementData[]>();
  const [loadingPage, setLoadingPage] = useState(true);
  const [openAttchamentsDialog, setOpenAttachmentsDialog] = useState(false);
  const [openAssociationDialog, setOpenAssociationDialog] = useState(false);
  const [workOrdersToAssociate, setWorkOrdersToAssociate] = useState<
    AssociationWOData[]
  >([]);
  const [associatedList, setAssociatedList] = useState<AssociationWOData[]>([]);
  const [hasAssociation, setHasAssociation] = useState(false);
  const [completionData, setCompletionData] = useState<
    CompletionData | undefined
  >();
  const [loadingCompletion, setLoadingCompletion] = useState(false);

  const navigate = useNavigate();

  const onCloseAttachments = (): void => setOpenAttachmentsDialog(false);
  const onOpenAssociateDialog = (): void => setOpenAssociationDialog(true);
  const onCloseAssociateDialog = (): void => setOpenAssociationDialog(false);
  const navigateBack = (): void => navigate('/archived');

  const {
    getArchivedMatchRegistryWorkOders,
    getAssociatedListCallback,
    loading,
    associateLoading,
    handleWorkOrderAssociation,
  } = useAssociateWorkOrder();

  const {
    openSnackbar,
    setOpenSnackbar,
    setErrorMessage,
    setSnackbarMessage,
    isHiveOwner,
  } = useContext(GlobalContext);

  const { getErrorMessage } = useErrorMessage();
  const { osId } = useGeneral();
  const { handleRooms, rooms } = useRooms();
  const {
    expandOne,
    setExpandOne,
    expandTwo,
    setExpandTwo,
    expandThree,
    setExpandThree,
    expandFour,
    setExpandFour,
    expandFive,
    setExpandFive,
    expandSix,
    setExpandSix,
    expandSeven,
    setExpandSeven,
    expandEight,
    setExpandEight,
    expandNine,
    setExpandNine,
    expandTen,
    setExpandTen,
    expandAll,
    setExpandAll,
    toggleAccordions,
  } = useAccordion();

  useEffect(() => {
    if (
      expandOne &&
      expandTwo &&
      expandThree &&
      expandFour &&
      expandFive &&
      expandSix &&
      expandSeven &&
      expandEight &&
      expandNine &&
      expandTen
    ) {
      setExpandAll(true);
    } else {
      setExpandAll(false);
    }
  }, [
    expandOne,
    expandTwo,
    expandThree,
    expandFour,
    expandFive,
    expandSix,
    expandSeven,
    expandEight,
    expandNine,
    expandTen,
  ]);
  const hasAssociationRef = useRef(false);

  const isLegacyCharacteristicsData =
    propertyData?.property_characteristics_form
      ? 'uses' in
        (propertyData.property_characteristics_form as unknown as Record<
          string,
          unknown
        >)
      : false;

  const getCharacteristicsCompletion = async (): Promise<void> => {
    setLoadingCompletion(true);
    try {
      const response = await getCompletion(osId);

      if (response.detail.description)
        throw new Error(response.detail.description);

      if (!response.data) throw new Error('Algo deu errado, tente novamente.');

      setCompletionData(response.data);
    } catch (error) {
      setSnackbarMessage(getErrorMessage(error));
      setOpenSnackbar(true);
      setErrorMessage(true);
    } finally {
      setLoadingCompletion(false);
    }
  };

  const associationListCallback = useCallback(async () => {
    if (!osId) return;

    const result = await getAssociatedListCallback(osId);
    setAssociatedList(result);

    const hasAssociationData = result.length > 0;
    setHasAssociation(hasAssociationData);
    hasAssociationRef.current = hasAssociationData;
  }, [osId]);

  const checkRegistry = async (): Promise<void> => {
    if (!propertyData || hasAssociationRef.current) return;
    if (
      !propertyData.book ||
      !propertyData.registration_number ||
      !propertyData.registry_office
    )
      return;

    const params: CheckWorkOrderRegistryParams = {
      book: propertyData.book,
      registration_number: propertyData.registration_number,
      registry_office: propertyData.registry_office,
      exclude_work_order_id: propertyData.id,
    };

    const result = await getArchivedMatchRegistryWorkOders(params);
    setWorkOrdersToAssociate(result);
  };

  const getDataCallback = useCallback(async () => {
    let getSamples = false;
    let isFactors = false;

    try {
      const response = await GetWorkOrder(osId);

      if (response.detail.description) {
        throw new Error(response.detail.description);
      }

      if (!response.data || response.data.status !== Status.ARCHIVED) {
        throw new Error('Algo deu errado, tente novamente.');
      }

      if (response.data.samples) {
        getSamples = true;
      }

      if (factorTypes.includes(response.data.evaluation_type)) {
        isFactors = true;
      }

      if (response.data.inspection) {
        handleRooms(response.data.inspection.id);
      }
      setPropertyData(response.data);
      setLoadingPage(false);
    } catch (error) {
      setSnackbarMessage(getErrorMessage(error, true));
      setErrorMessage(true);
      setOpenSnackbar(true);
    }

    if (getSamples) {
      try {
        const response = await getSample(osId, 1, 105);
        if (response.detail.description) {
          throw new Error(response.detail.description);
        }
        if (!response.data) {
          throw new Error('A amostra não pode ser carregada.');
        }

        if (isFactors) {
          const filteredSamples: ElementData[] = response.data.items.filter(
            (data) => data.is_utilized
          );
          setSampleData(filteredSamples);
          return;
        }
        setSampleData(response.data.items);
      } catch (error) {
        setSnackbarMessage(getErrorMessage(error));
        setOpenSnackbar(true);
        setErrorMessage(true);
      }
    }
  }, [osId]);

  useEffect(() => {
    getDataCallback();
  }, [getDataCallback]);

  useEffect(() => {
    if (propertyData) {
      associationListCallback().then(() => {
        checkRegistry();
      });
    }
  }, [propertyData]);

  useEffect(() => {
    if (propertyData?.property_characteristics_form)
      getCharacteristicsCompletion();
  }, [propertyData]);

  const handleAssociation = useCallback(async () => {
    if (workOrdersToAssociate.length > 0) {
      const associateIds = workOrdersToAssociate.map((os) => os.id);
      const successMessage = 'Ordem de serviço associada com sucesso!';
      const props: AssociateProps = {
        data: {
          osId,
          bodyData: {
            work_order_ids: associateIds,
          },
        },
        successMessage,
        callback: associationListCallback,
      };
      onCloseAssociateDialog();
      await handleWorkOrderAssociation(props);
    }
  }, [osId, workOrdersToAssociate]);

  return (
    <GridContainer>
      <BackButton onClick={navigateBack}>{IconArrowCircleLeftMS}</BackButton>
      <BoxContainer>
        <Title
          osNumber={propertyData?.reference_number || 0}
          title={Constants.archived}
          createdAt={propertyData?.created_at}
        />
        {loadingPage ? (
          <LoadingBox>
            <ColoredCircularProgress />
          </LoadingBox>
        ) : (
          <>
            <FlexSpaceBetweenBox>
              <Box>
                <InputTitle>{Constants.reason}</InputTitle>
                <StyledInput>
                  {convertArchivedReason(propertyData?.archived_reason)}
                </StyledInput>
              </Box>
              <Box display="flex" gap={1.2}>
                {isHiveOwner &&
                  propertyData &&
                  propertyData.worker_company_id !== null && (
                    <MessagesDialog
                      osId={osId}
                      hiveRequest={propertyData.hive_request || undefined}
                    />
                  )}
                <AllAttachments
                  propertyData={propertyData}
                  osId={osId}
                  open={openAttchamentsDialog}
                  onClose={onCloseAttachments}
                />
              </Box>
            </FlexSpaceBetweenBox>
            <ClientData propertyData={propertyData} showProgressBar={false} />
            <Box>
              <ToogleAccordion expand={expandAll} toogle={toggleAccordions} />
              <SectionBox>
                <AccordionTitle
                  title={Constants.propertyData}
                  icon={IconApartmentMS}
                  openAccordion={expandOne}
                  setOpenAccordion={setExpandOne}
                />
                {expandOne && <PropertyData propertyData={propertyData} />}
              </SectionBox>
              <SectionBox>
                <AccordionTitle
                  title={Constants.propertyAddress}
                  icon={IconLocationOnMS}
                  openAccordion={expandTwo}
                  setOpenAccordion={setExpandTwo}
                />
                {expandTwo && (
                  <PropertyAddressWithMaps
                    checkLocation
                    propertyData={propertyData}
                  />
                )}
              </SectionBox>
              <SectionBox>
                <AccordionTitle
                  title={Constants.propertyDetails}
                  icon={IconLocationCityMS}
                  openAccordion={expandThree}
                  setOpenAccordion={setExpandThree}
                />
                {expandThree && <PropertyInfo propertyData={propertyData} />}
              </SectionBox>
              <SectionBox>
                <AccordionTitle
                  title={Constants.scheduleInfo}
                  icon={IconCalendarTodayMS}
                  openAccordion={expandFour}
                  setOpenAccordion={setExpandFour}
                />
                {expandFour && (
                  <Box>
                    {propertyData?.inspection?.engineer_id ? (
                      <ScheduleInfo
                        inspectionData={propertyData.inspection}
                        rooms={rooms}
                        workerCompanyId={
                          propertyData.worker_company_id || undefined
                        }
                      />
                    ) : (
                      <Typography>{Constants.noInspection}</Typography>
                    )}
                  </Box>
                )}
              </SectionBox>
              <SectionBox>
                <AccordionTitle
                  title={Constants.propertyPhotos}
                  icon={IconPhotoLibraryMS}
                  openAccordion={expandFive}
                  setOpenAccordion={setExpandFive}
                />
                {expandFive && (
                  <Box>
                    {propertyData?.inspection && rooms.length > 0 ? (
                      <Rooms
                        navigationPath={`${osId}/inspection/${propertyData.inspection.id}/rooms`}
                        rooms={rooms}
                        osId={osId}
                        inspectionId={propertyData.inspection.id}
                      />
                    ) : (
                      <Typography>{Constants.noPhotos}</Typography>
                    )}
                  </Box>
                )}
              </SectionBox>
              <SectionBox>
                <AccordionTitle
                  title={Constants.form}
                  icon={IconListAltMS}
                  openAccordion={expandSix}
                  setOpenAccordion={setExpandSix}
                />
                {expandSix && (
                  <Box>
                    {propertyData?.inspection?.form_response ? (
                      <FormResponse
                        questionForm={propertyData.inspection.form_response}
                      />
                    ) : (
                      <Typography>{Constants.noForm}</Typography>
                    )}
                  </Box>
                )}
              </SectionBox>
              <SectionBox>
                <AccordionTitle
                  title={Constants.sample}
                  icon={IconFactCheckMS}
                  openAccordion={expandSeven}
                  setOpenAccordion={setExpandSeven}
                />
                {expandSeven && (
                  <Box>
                    {sampleData && sampleData?.length > 0 ? (
                      <SampleSection
                        sampleData={sampleData}
                        propertyData={propertyData}
                      />
                    ) : (
                      <Typography>{Constants.noSample}</Typography>
                    )}
                  </Box>
                )}
              </SectionBox>
              {propertyData?.property_characteristics_form && (
                <SectionBox>
                  <AccordionTitle
                    title={Constants.characteristics}
                    icon={IconAssignmentMS}
                    openAccordion={expandNine}
                    setOpenAccordion={setExpandNine}
                  />
                  {expandNine && (
                    <CharacteristicsSectionSummary
                      completionData={completionData}
                      loadingCompletion={loadingCompletion}
                      isLegacyCharacteristicsData={isLegacyCharacteristicsData}
                    />
                  )}
                </SectionBox>
              )}
              {propertyData?.avm_status !== null && (
                <SectionBox>
                  <AccordionTitle
                    title={Constants.report}
                    icon={IconEngineeringMS}
                    openAccordion={expandEight}
                    setOpenAccordion={setExpandEight}
                  />
                  {expandEight && <ReportDownload id={osId} />}
                </SectionBox>
              )}
              <SectionBox>
                <AccordionTitle
                  title={Constants.pdfReport}
                  icon={IconDescriptionMS}
                  openAccordion={expandTen}
                  setOpenAccordion={setExpandTen}
                />
                {expandTen && <PdfViewer osId={osId} />}
              </SectionBox>
              {propertyData?.report_xlsx && !propertyData.report_pdf && (
                <SubmitBox>
                  <ExportSample
                    osId={osId}
                    title={Constants.exportElementsList}
                  />
                </SubmitBox>
              )}
              <AssociatedWorkOrders osId={osId} list={associatedList} />
            </Box>
            {!hasAssociation && workOrdersToAssociate.length > 0 && (
              <FlexReverseBox>
                <Button
                  disabled={loading || associateLoading}
                  onClick={onOpenAssociateDialog}
                >
                  {loading || associateLoading ? (
                    <WhiteCircularProgress size={22} />
                  ) : (
                    Constants.addWO
                  )}
                </Button>
              </FlexReverseBox>
            )}
          </>
        )}
      </BoxContainer>
      {openSnackbar && <Snackbar />}
      <AssociateWorkOrderDialog
        workOrders={workOrdersToAssociate}
        handleClose={onCloseAssociateDialog}
        open={openAssociationDialog}
        registerNumber={propertyData?.registration_number || ''}
        callback={handleAssociation}
      />
    </GridContainer>
  );
}
